import { createContext } from 'react'

export const FormContext = createContext({
  formStatus: {},
  visibleModal: '',
  prevStep: () => {},
  setLoading: () => {},
  setVisibleModal: () => {},
})
